<template>
  <div class="main-container">
    <div class="main-container-title-box">
      <div class="main-container-title-box-text">
        <span class="title-box-text"> Роли </span>
      </div>
      <v-spacer></v-spacer>
      <v-btn style="width: auto !important" class="button-accept" @click="openDialog">
        + Добавить роль
      </v-btn>
    </div>

    <div class="table-container">
      <v-data-table :headers="tableHeaders" :items="items" class="elevation-0 main-table" :disable-pagination="true"
        :hide-default-footer="true" fixed-header @click:row="onClickItem">
        <template v-slot:item.sections="{ item }">
          <span v-for="(i, index) in findTrueItems(item.sections)" :key="index">
            <template v-if="index < findTrueItems(item.sections).length - 1">
              {{ i.title }}, &nbsp;
            </template>
            <template v-else>
              {{ i.title }}
            </template>
          </span>
        </template>
      </v-data-table>
    </div>

    <v-dialog width="570px" height="auto" persistent v-model="dialog">
      <v-card width="570px" height="auto" class="rounded-0">
        <v-form ref="formFirst">
          <v-card-title class="dialog-title">
            <span v-if="selectedItem && selectedItem.id" class="title">Редактировать роль</span>
            <span v-else class="title">Добавить роль</span>
            <v-icon @click="closeDialog">mdi-close</v-icon>
          </v-card-title>
          <v-card-text class="dialog-description">
            <v-text-field style="margin-top: 20px" label="Роль" required type="text" outlined :rules="rules"
              v-model="selectedItem.title"></v-text-field>

            <div class="dialog-description-text">
              Настройте доступы разделов для данной роли.
            </div>
            <div class="dialog-description-table">
              <v-data-table :headers="tableSecondHeaders" :items="sections.filter((i) => !i.isHidden)"
                class="elevation-0 dialog-table" :disable-pagination="true" :hide-default-footer="true" fixed-header>
                <template v-slot:item.accesses="{ item }">
                  <v-autocomplete class="mt-8" outlined small-chips deletable-chips multiple item-text="name"
                    item-value="key" v-model="item.activeItems" :items="item.accesses"></v-autocomplete>
                </template>
              </v-data-table>
              <v-divider></v-divider>
            </div>
          </v-card-text>
          <v-card-actions class="dialog-buttons">
            <v-btn style="width: 120px !important" @click="addRole" class="button-accept">
              Сохранить
            </v-btn>
            <v-btn v-if="selectedItem && selectedItem.id" @click="dialogDelete = true" style="width: 120px !important"
              class="button-accept-outlined" outlined color="var(--app-red-1)">
              Удалить
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
    <v-dialog width="600px" height="auto" persistent v-model="dialogDelete">
      <v-card>
        <v-card-title class="dialog-title">
          <span class="title">Точно хотите удалить роль?</span>
          <v-icon @click="dialogDelete = false">mdi-close</v-icon>
        </v-card-title>
        <v-card-actions class="dialog-buttons">
          <v-btn @click="dialogDelete = false" style="width: 120px" outlined color="var(--app-green-1)">
            Нет
          </v-btn>
          <v-btn @click="deleteRole" style="width: 120px" outlined color="var(--app-red-1)">
            Да
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-divider></v-divider>
  </div>
</template>
<script>


export default {
  data: () => ({
    showInfo: false,
    x: null,
    y: null,
    items: [],
    dialog: false,
    dialogDelete: false,
    rules: [(value) => !!value || "Обязательно к заполнению"],
    selectedItem: {},

    tableHeaders: [
      {
        text: "Роль",
        sortable: false,
        value: "title",
      },
      {
        text: "Доступ",
        sortable: false,
        value: "sections",
      },
    ],
    tableSecondHeaders: [
      {
        text: "Раздел",
        sortable: false,
        value: "title",
      },
      {
        text: "Доступ",
        sortable: false,
        value: "accesses",
      },
    ],

    sections: [],
    sectionsAll: [],
  }),
  methods: {
    openInfo(e) {
      e.preventDefault();
      this.x = e.clientX + 10;
      this.y = e.clientY + 10;
      this.showInfo = true;
    },
    goToCreate() {
      this.$router.push({ name: "CreateCategories" });
    },
    findTrueItems(items) {
      const newArr = items.filter((i) => {
        const findItems = i.accesses.find((it) => it.value);
        if (findItems) {
          return i;
        }
      });
      return newArr;
    },

    getItems() {
      this.$axios
        .get(
          this.$store.getters.apiAdminPanelV2 + "/adminPanelUser/role/list",
          {
            headers: {
              authorization: this.$store.getters.adminPanelHeaderAuth,
            },
          }
        )
        .then((res) => {
          this.items = res.data;
        })
        .catch((err) => {
          this.$store.commit("errorSet", true);
          this.$store.commit("errorTextSet", err);
        });
    },
    getSections() {
      this.$axios
        .get(
          this.$store.getters.apiAdminPanelV2 + "/adminPanelUser/section/list",
          {
            headers: {
              authorization: this.$store.getters.adminPanelHeaderAuth,
            },
          }
        )
        .then((res) => {
          this.sectionsAll = res.data;
          this.sections = res.data;
        })
        .catch((err) => {
          this.$store.commit("errorSet", true);
          this.$store.commit("errorTextSet", err);
        });
    },
    onClickItem(item) {
      this.selectedItem = Object.assign({}, item);
      this.sections = JSON.parse(JSON.stringify(this.selectedItem.sections));
      this.sectionsAll.forEach((element) => {
        if (!this.sections.filter((i) => i.key == element.key)[0]) {
          this.sections.push(element);
        }
      });
      for (const element of this.sections) {
        element.activeItems = [];
        for (const el of element.accesses) {
          if (el.value) {
            element.activeItems.push(el.key);
          }
        }
      }
      this.dialog = true;
    },
    openDialog() {
      this.getSections();
      this.dialog = true;
    },
    closeDialog() {
      this.dialog = false;
      setTimeout(() => {
        this.selectedItem = {};
        this.$refs.formFirst.resetValidation();
      }, 100);
    },
    deleteRole() {
      this.$axios
        .delete(this.$store.getters.apiAdminPanelV2 + "/adminPanelUser/role", {
          headers: {
            authorization: this.$store.getters.adminPanelHeaderAuth,
          },
          params: {
            roleId: this.selectedItem.id,
          },
        })
        .then(() => {
          this.getItems();
          this.dialogDelete = false;
          this.closeDialog();
        })
        .catch((err) => {
          this.$store.commit("errorSet", true);
          this.$store.commit("errorTextSet", err);
        });
    },
    addRole() {
      if (this.$refs.formFirst.validate()) {
        for (let index = 0; index < this.sections.length; index++) {
          const element = this.sections[index];
          if (element.activeItems && element.activeItems.length > 0) {
            for (let ind = 0; ind < element.accesses.length; ind++) {
              const el = element.accesses[ind];
              const newItem = element.activeItems.find((i) => i == el.key);
              if (newItem) {
                el.value = true;
              } else {
                el.value = false;
              }
            }
          } else {
            for (let i = 0; i < element.accesses.length; i++) {
              const el = element.accesses[i];
              el.value = false;
            }
          }
          delete element.activeItems;
        }

        this.$axios
          .post(
            this.$store.getters.apiAdminPanelV2 + "/adminPanelUser/role",
            {
              roleId: this.selectedItem.id ? this.selectedItem.id : "",
              title: this.selectedItem.title,
              sections: this.sections,
            },
            {
              headers: {
                authorization: this.$store.getters.adminPanelHeaderAuth,
              },
            }
          )
          .then(() => {
            this.closeDialog();
            this.getItems();
            this.getSections();
          })
          .catch((err) => {
            this.$store.commit("errorSet", true);
            this.$store.commit("errorTextSet", err);
          });
      }
    },
  },
  created() {
    this.getItems();
    this.getSections();
  },
};
</script>
<style lang="scss" scoped>
.table-container {
  height: calc(100vh - 190px);

  .main-table {
    height: calc(100vh - 190px) !important;
    min-height: calc(100vh - 190px) !important;
    max-height: calc(100vh - 190px) !important;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
}
</style>